import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { CookiesService } from './cookies.service';
import { CookieService } from 'ngx-cookie-service';
import { PrivacyService } from '../privacy/privacy.service';
import { policy } from '../privacy/privacy.model';
import { constants } from '../constants';

interface ItemCookie {
  name:string, 
  isMandatory:boolean
}
interface Cookies {
  [index :number]: ItemCookie
}

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})

export class MainMenuCookiesComponent implements OnInit {

  

  textMainMenu: string
  linkCookies:any
  textSubMenu:any
  cookies:Cookies[] = []

  constructor(  private cookiesService : CookiesService,
                private cookieService: CookieService,
                private privacyService: PrivacyService
                ) { }

  ngOnInit() {
    this.getDataMainModal()
    this.getLinkCookies()
  }
  
  getDataMainModal(){
    this.cookiesService.getGroupParameters("TEXTOS_COOKIE").subscribe(((dataResponse:any) => {
      this.textMainMenu = dataResponse.obj[0].value
      this.textSubMenu = dataResponse.obj
      $('#btnModal').trigger( "click" );

      dataResponse.obj.forEach(element => {
        if (element.name != "Información básica sobre cookies" && element.name != "INSTRUCCIONES") {
          let object = {
            isMandatory: element.name == "Cookies técnicas" ? true :false,
            name: element.name
          }
          this.cookies.push(object)
        }
      });
    })) 
  }
  getLinkCookies(){

    this.privacyService.getAllPolicy().subscribe(((dataResponse:any) => {
      if (dataResponse['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE) {
        this.linkCookies = dataResponse.obj.filter((item:policy) => {
          return item.policyType.includes("POLITICA COOKIES")
        })
        this.linkCookies = this.linkCookies.length > 0 && this.linkCookies[0].documentLink.link
      }
    }))
  }
  openSubModal(){
    $('#btnSubModal').trigger( "click" );
    this.changeSelectedItem(this.textSubMenu[1].id)
    this.closeModal()
  }
  onChangeCookiesSwitch(event){
    let cookieName = event.target.id.split("-")[1]
    this.cookieService.set(cookieName, event.target.checked, 30, "/", "", false, "Strict");
  }
  onClicAllowAll(){
   this.saveCookies()
   this.closeSubModal()
  }
  onClicAceptAll(){
    this.saveCookies()
    this.closeModal()
  }
  saveSettings(){
    this.cookieService.set("Cookies técnicas", "true", 30, "/", "", false, "Strict");
    this.saveCookies()
    this.closeSubModal()
  }
  saveCookies(){
    this.cookies.forEach( (element) => {
      this.cookieService.get(element['name']) == "" && this.cookieService.set(element['name'], element['isMandatory'] + "", 30, "/", "", false, "Strict");
    });
  }
  changeSelectedItem( item : any ){
    $('.texts').hide()
    $('.selected').removeClass("selected")
    $('#'+item).show()
    $('#button-item-'+item).addClass("selected")
  }
  closeModal(){
    $('#closeModal').trigger( "click" );
  }
  closeSubModal(){
    $('#btnSubModal').trigger( "click" );
  }
}
